
import geo from '../../../assets/js/base/_geolocate.js';
import axios from 'axios';
import classnames from 'classnames';
import Mustache from 'mustache';


class CampaignPromo {
	selectors = {
		templateEl:  '#member-campaign-promo',
		hasParticipating: 'member-campaign-promo--has-participants',
		zipCTA: '.member-campaign-promo__zip-form-cta',
		ctaContent: '.cta__content',
		zipForm: 'member-campaign-promo__zip-form',
		optOutBar: '.member-campaign-promo__opt-out-bar',
		zipPlaceholder: '.member-campaign-promo__zip-form--placeholder',
		defaultContent: '.member-campaign-promo__default-content',
		template: {
			featured_image: '.member-campaign-promo__image',
			promo_title: '.member-campaign-promo__promo-title',
			banner_title: '.member-campaign-promo__opt-out-banner__title',
			promo_content: '.member-campaign-promo__content',
			promo_excerpt: '.member-campaign-promo__excerpt',
		},
		showFallback: 'member-campaign-promo--show-fallback',
		noResults: 'member-campaign-promo--no-results',
		fallback: 'member-campaign-promo__fallback',
		loading: 'is-loading',
	};

	constructor(node) {
        let lang = window.wdg.weglot_lang ?? '';
		const { selectors: { template, loading, templateEl } } = this;
        this.node = node;
		this.clones = [];
		this.initial = true;
        this.node.classList.add(loading);
        this.endpoint = `${window.location.origin}${lang}/wp-json/ccusa/v2/campaign_promo?`;
        this.template = this.node.querySelector(templateEl);
        this.api = axios;

		console.log(this.endpoint);

        this.initialize();
    }

	async initialize() {
		this.initFallback();

		this.zip_code = await geo.locate()
			.then(resp => resp.zip_code)
			.catch(error => console.error(error));

		if (this.zip_code) {
			await this.retrievePost()
		} else {
			this.removeClones();
		}
    }

	initFallback() {
		const { selectors: { template: { promo_title }, fallback, zipCTA, optOutBar } } = this;

		const _fallback = document.createElement('div');
		_fallback.innerHTML = this.template.innerHTML;
		_fallback.classList.add(fallback);

		// trim out unnecessary data
		const banner = _fallback.querySelector(optOutBar);
		const title = _fallback.querySelector(promo_title);
		banner.parentNode.removeChild(banner);
		title.parentNode.removeChild(title);

		this.fallback = _fallback;
		this.zipCta = _fallback.querySelector(zipCTA);
		this.initZipForm();
	}
	initZipForm() {
		const { selectors: { ctaContent, zipForm, zipPlaceholder }, zipCta } = this;

		const form = document.createElement('form', {
			classList: [zipForm],
		});
		const input = document.createElement('input')
		input.type = 'text';
		input.maxLength = 5;
		input.name = 'zip_code';

		form.append(input);
		form.addEventListener('submit', (event) => { event.preventDefault() });

		// out with the old
		zipCta.querySelector(zipPlaceholder)
			.parentNode.removeChild(zipCta.querySelector(zipPlaceholder));

		// in with the new
		form && zipCta.querySelector(ctaContent).append(form);
		this.node.prepend(zipCta);

		this.form_input = form.querySelector('input');
		this.form_input.addEventListener('keyup', (event) => { this.onFormKeyUp(event) });
	};


	onFormKeyUp(event) {
		const { form_input: { value } } = this;
		this.initial = false;

		this.zip_code = (value.length == 5) ? value : false;
		this.zip_code && this.retrievePost();
	}

	async retrievePost() {
        const { zip_code, endpoint, api, node, selectors: { noResults } } = this;
        const url = `${endpoint}${new URLSearchParams({ zip_code })}`;
		node.classList.remove(noResults);
		this.data = await api.get(url).then(resp => resp.data );
		this.data ? this.processResponse() : console.error('Campaign Promo JS: nothing returned from api',);
    }

	removeClones() {
		const { node, clones, selectors: { template, loading } } = this;
		node.classList.remove(loading);
		clones && clones.map(el => el.parentNode.removeChild(el));
		return [];
	}

	processResponse() {
        const { data, node, fallback, selectors: { template, zipCTA, defaultContent, hasParticipating } } = this;

		this.clones = this.removeClones();

        const clones = data.map(response => {
			const { featured_image, promo_excerpt, promo_title } = response;
            const el = document.createElement('div');

			el.innerHTML = this.doTemplating(this.template.innerHTML, response);

            Object.entries(template).forEach(([type, selector]) => {
				response.banner_title = promo_title;
                el.querySelectorAll(selector) && response[type] && [...el.querySelectorAll(selector)].map((b) => {
					b.innerHTML = response[type];
				});

            });

			if (!response.promo_excerpt) {
				const b = el.querySelector('.member-campaign-promo__default-content');
				b.parentNode.removeChild(b);
			}

			if (!response.promo_excerpt ) {
				response.featured_image = null;
				el.innerHTML += fallback.innerHTML;
			}
            el.classList = this.applyVisiblityClasses(response);
			el.participating = response.promo_excerpt;

			// remove new zip form
			const form = el.querySelector(zipCTA);
			form && form.parentNode.removeChild(form);
			return el;
        });

		const participating = clones.filter((e) => e.participating);

		participating.length
			? node.classList.add(hasParticipating)
			: node.classList.remove(hasParticipating);

		this.clones = this.initial ? participating : clones;
		this.clones.length ? clones.map(function(c) { node.append(c) } ) : this.handleNoResults();
    }


	handleNoResults() {
		const { node, fallback, selectors: { noResults }} = this;
		node.append(fallback);
		node.classList.add(noResults);
	}


	doTemplating(template, data) {
		return Mustache.render(template, data);
	}

	applyVisiblityClasses(data) {
		return classnames(
			{
				'member-campaign-promo': true,
				'member-campaign-promo--has-form': data.show_form,
				'member-campaign-promo--has-promo-url': data.donate_url,
				'member-campaign-promo--has-promo-title': data.promo_title,
				'member-campaign-promo--participating': data.promo_excerpt,
				'member-campaign-promo--non-participating': !data.promo_excerpt,
				'member-campaign-promo--has-website-url': data.member_website_url,
			});
	}
}

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.member-campaign-promo').forEach(node => {
		new CampaignPromo( node );
	} );
});

export default CampaignPromo;
